import * as Page from '../../components/content/page-header';
import { MainContent } from '../../components/layout/content';
import React, { useEffect, useState } from 'react';
import { PageHeader } from '../../components/layout/page-header';
import { useNavigate } from 'react-router';
import { axiosInstance } from '../../api/api';
import ChannelModal from '../../components/modals/channel-modal';

interface Channel {
  _id: string;
  name: string;
  avatar: string;
}

export const Channels = (): JSX.Element => {
  const navigate = useNavigate();
  const [channels, setChannels] = useState<Channel[]>([]);
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = (): void => {
    setShowModal(true);
  };

  const handleCloseModal = (): void => {
    setShowModal(false);
  };

  const handleButtonClick = (button: any): void => {
    if (button.type === 'modal') {
      handleOpenModal();
    }
  };

  const handleSuccess = (): void => {
    void fetchChannels();
  };

  async function fetchChannels(): Promise<void> {
    try {
      const response = await axiosInstance().get('/channels');
      setChannels(response.data);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    void fetchChannels();
  }, []);

  return (
    <>
      <Page.Header>
        <PageHeader
          title="Channels"
          buttons={[{ title: 'Create Channel', type: 'modal' }]}
          onClick={handleButtonClick}
        />
      </Page.Header>
      <MainContent>
        <div className="channel-list">
          {channels.map((channel) => (
            <div
              key={channel._id}
              className="channel-item"
              onClick={(): void => navigate(`/channels/${channel._id}`)}>
              <p key={channel._id}>{channel.name}</p>
            </div>
          ))}
        </div>

        <ChannelModal show={showModal} onClose={handleCloseModal} onSave={handleSuccess} />
      </MainContent>
    </>
  );
};
